import { Button, Flex, Typography } from '@iheartjane/reefer';

import type { ReviewableProduct } from '../../reviewableProduct';
import { MoreToReviewList } from '../moreToReviewList/moreToReviewList';
import { RateAndReviewModal } from '../rateAndReviewModal/rateAndReviewModal';

export interface ChooseProductToReviewProps {
  moreToReview: ReviewableProduct[];
  onDone: () => void;
  onReviewProduct: (product: ReviewableProduct) => void;
  testId?: string;
}

/**
 * Rate & Review phase reached by going back from a review, shared by every
 * A/B test variant. Lists the products to review without a confirmation.
 */
export function ChooseProductToReview({
  moreToReview,
  onDone,
  onReviewProduct,
  testId = 'choose-product-to-review',
}: ChooseProductToReviewProps) {
  return (
    <>
      <RateAndReviewModal.Body testId={testId}>
        <Flex alignItems="center" flexDirection="column" width="100%">
          <Typography as="h2" textAlign="center" variant="h3-semibold">
            Choose a product to review
          </Typography>
          <Typography color="grays-mid" mt={8} mb={24} textAlign="center">
            Help your community by reviewing products.
          </Typography>
          <MoreToReviewList
            heading={`${moreToReview.length} to review`}
            headingLevel="h3"
            onReviewProduct={onReviewProduct}
            products={moreToReview}
            testId={testId}
          />
        </Flex>
      </RateAndReviewModal.Body>
      <RateAndReviewModal.Footer>
        <Button label="I'm done" onClick={onDone} variant="tertiary" />
      </RateAndReviewModal.Footer>
    </>
  );
}
